var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect } from "react";
import { Plus, Loader2, RefreshCw, Monitor } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { getClients, createClient, deleteClient, associateAccounts } from "../../actions/clients";
import { updateAgencyCache } from "../../actions/platforms";
import { getUserData } from "../../actions/users";
import { showToast } from "../../utils/toastUtils";
import ClientTableRow from "./ClientTableRow";
import ConfirmationModal from "../common/ConfirmationModal";
import { useLoadingWithSnakeModal } from "../../hooks/useLoadingWithSnakeModal";
import { getMySubscriptions } from "../../actions/subscriptions";
import { trackFirstClientCreated } from "../../utils/tracking";
import { usePremiumAccess } from "../../hooks/usePremiumAccess"; // ✅ Importa o hook centralizado
var ClientTable = function (_a) {
    var _b, _c;
    var _d = _a.clients, clients = _d === void 0 ? [] : _d, _e = _a.agency, agency = _e === void 0 ? {} : _e, _f = _a.googleAccounts, googleAccounts = _f === void 0 ? [] : _f, _g = _a.facebookAccounts, facebookAccounts = _g === void 0 ? [] : _g, loadingGoogleAccounts = _a.loadingGoogleAccounts, loadingFacebookAccounts = _a.loadingFacebookAccounts, loadingInstagramAccounts = _a.loadingInstagramAccounts, isGoogleConnected = _a.isGoogleConnected, isFacebookConnected = _a.isFacebookConnected, setLoadingGoogleAccounts = _a.setLoadingGoogleAccounts, setLoadingFacebookAccounts = _a.setLoadingFacebookAccounts, setLoadingInstagramAccounts = _a.setLoadingInstagramAccounts, _h = _a.instagramAccounts, instagramAccounts = _h === void 0 ? [] : _h;
    var _j = useState(null), notification = _j[0], setNotification = _j[1];
    var _k = useState(true), isLoadingClients = _k[0], setIsLoadingClients = _k[1];
    var _l = useState(clients), localClients = _l[0], setLocalClients = _l[1];
    var _m = useState([]), originalClients = _m[0], setOriginalClients = _m[1];
    var _o = useState(""), newClientName = _o[0], setNewClientName = _o[1];
    var _p = useState(false), isAddingClient = _p[0], setIsAddingClient = _p[1];
    var _q = useState(null), clientToDelete = _q[0], setClientToDelete = _q[1];
    var _r = useState(false), isSyncing = _r[0], setIsSyncing = _r[1];
    var _s = useLoadingWithSnakeModal(7000), showSnakeModal = _s.showSnakeModal, runWithSnakeModal = _s.runWithSnakeModal;
    var navigate = useNavigate();
    var _t = useState([]), activeSubscriptions = _t[0], setActiveSubscriptions = _t[1];
    var _u = useState(false), orderChanged = _u[0], setOrderChanged = _u[1];
    var _v = useState(null), currentUserData = _v[0], setCurrentUserData = _v[1];
    var _w = useState(false), showConnectWarning = _w[0], setShowConnectWarning = _w[1];
    // ✅ Usa o hook centralizado para acesso premium/trial
    var _x = usePremiumAccess(), hasPremiumAccess = _x.hasPremiumAccess, isInTrialPeriod = _x.isInTrialPeriod, hasActivePlan = _x.hasActivePlan, trialDaysLeft = _x.trialDaysLeft, trialCreatedAt = _x.trialCreatedAt, isPremiumLoading = _x.isLoading;
    useEffect(function () {
        if (notification) {
            var timer_1 = setTimeout(function () { return setNotification(null); }, 3000);
            return function () { return clearTimeout(timer_1); };
        }
    }, [notification]);
    useEffect(function () {
        function fetchUser() {
            return __awaiter(this, void 0, void 0, function () {
                var user, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, getUserData()];
                        case 1:
                            user = _a.sent();
                            setCurrentUserData(user);
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            console.error("Erro ao buscar dados do usuário:", error_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        fetchUser();
        var fetchClients = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, updatedClients, tempClients, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getClients()];
                    case 1:
                        response = _a.sent();
                        updatedClients = response.data
                            .sort(function (a, b) { var _a, _b; return ((_a = a.display_order) !== null && _a !== void 0 ? _a : 0) - ((_b = b.display_order) !== null && _b !== void 0 ? _b : 0); })
                            .map(function (client) {
                            var _a;
                            return ({
                                id: String(client.id),
                                name: client.name,
                                google: client.google_customer_id ? String(client.google_customer_id) : '',
                                google_mcc_id: client.google_mcc_id ? String(client.google_mcc_id) : null,
                                facebook: client.fb_account_id ? String(client.fb_account_id) : '',
                                instagram: client.instagram_account_id ? String(client.instagram_account_id) : '',
                                status: client.status !== undefined ? client.status : true,
                                onboarded_at: client.onboarded_at || null,
                                display_order: (_a = client.display_order) !== null && _a !== void 0 ? _a : 0,
                                isTemporary: false,
                            });
                        });
                        // ✅ Se não houver clientes, cria 3 clientes temporários
                        if (updatedClients.length === 0) {
                            tempClients = [
                                {
                                    id: 'temp-1',
                                    name: 'Cliente 1',
                                    google: null,
                                    facebook: null,
                                    instagram: null,
                                    status: true,
                                    onboarded_at: null,
                                    display_order: 0,
                                    isTemporary: true,
                                },
                                {
                                    id: 'temp-2',
                                    name: 'Cliente 2',
                                    google: null,
                                    facebook: null,
                                    instagram: null,
                                    status: true,
                                    onboarded_at: null,
                                    display_order: 1,
                                    isTemporary: true,
                                },
                                {
                                    id: 'temp-3',
                                    name: 'Cliente 3',
                                    google: null,
                                    facebook: null,
                                    instagram: null,
                                    status: true,
                                    onboarded_at: null,
                                    display_order: 2,
                                    isTemporary: true,
                                },
                            ];
                            setLocalClients(tempClients);
                        }
                        else {
                            setLocalClients(updatedClients);
                        }
                        setOriginalClients(updatedClients);
                        setIsLoadingClients(false);
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.error("Erro ao buscar clientes:", error_2);
                        showToast("error", "Erro ao carregar clientes");
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchClients();
    }, []);
    useEffect(function () {
        var fetchSubscriptions = function () { return __awaiter(void 0, void 0, void 0, function () {
            var subs, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getMySubscriptions()];
                    case 1:
                        subs = _a.sent();
                        setActiveSubscriptions(subs);
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        setActiveSubscriptions([]);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchSubscriptions();
    }, []);
    var handleFacebookAccountChange = function (facebookAccountId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!facebookAccountId) {
                return [2 /*return*/];
            }
            return [2 /*return*/];
        });
    }); };
    var handleClientChange = function (clientId, field, value) {
        setLocalClients(function (prevClients) {
            return prevClients.map(function (client) {
                var _a;
                if (client.id === clientId) {
                    var updatedClient = __assign(__assign({}, client), (_a = {}, _a[field] = value, _a));
                    if (field === 'google' && !value) {
                        updatedClient.google_mcc_id = null;
                    }
                    return updatedClient;
                }
                return client;
            });
        });
    };
    var handleSaveAssociation = function (clientId, googleCustomerId, facebookAccountId, instagramAccountId) { return __awaiter(void 0, void 0, void 0, function () {
        var client, googleMccId, error_4;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    client = localClients.find(function (c) { return c.id === clientId; });
                    googleMccId = (client === null || client === void 0 ? void 0 : client.google_mcc_id) || null;
                    return [4 /*yield*/, associateAccounts(clientId, googleCustomerId, facebookAccountId, instagramAccountId, (_a = client === null || client === void 0 ? void 0 : client.display_order) !== null && _a !== void 0 ? _a : 0, (client === null || client === void 0 ? void 0 : client.status) !== undefined ? client.status : true, (client === null || client === void 0 ? void 0 : client.name) || '', (client === null || client === void 0 ? void 0 : client.onboarded_at) || null, googleMccId)];
                case 1:
                    _b.sent();
                    showToast("success", "Associação salva com sucesso!");
                    navigate("/monitoramento");
                    return [3 /*break*/, 3];
                case 2:
                    error_4 = _b.sent();
                    console.error("Erro ao salvar associação:", error_4);
                    showToast("error", "Erro ao salvar associação. Tente novamente.");
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleAddClient = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, newClient_1, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Bloqueia se nenhuma plataforma estiver conectada
                    if (!isGoogleConnected && !isFacebookConnected) {
                        setShowConnectWarning(true);
                        return [2 /*return*/];
                    }
                    setShowConnectWarning(false);
                    if (reachedClientLimit) {
                        showToast("error", "Voc\u00EA atingiu o limite de ".concat(clientLimit, " clientes do seu plano."));
                        return [2 /*return*/];
                    }
                    if (!newClientName.trim()) {
                        showToast("error", "O nome do cliente não pode estar vazio.");
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, createClient(newClientName)];
                case 2:
                    response = _a.sent();
                    newClient_1 = response.data;
                    setLocalClients(function (prevClients) { return __spreadArray(__spreadArray([], prevClients, true), [
                        {
                            id: String(newClient_1.id),
                            name: newClient_1.name,
                            google: newClient_1.google_customer_id ? String(newClient_1.google_customer_id) : '',
                            facebook: newClient_1.fb_account_id ? String(newClient_1.fb_account_id) : '',
                            instagram: newClient_1.instagram_account_id ? String(newClient_1.instagram_account_id) : '',
                            isTemporary: false,
                        }
                    ], false); });
                    setNewClientName("");
                    // Conversão se for o primeiro cliente
                    if (localClients.length === 0) {
                        try {
                            trackFirstClientCreated({
                                email: currentUserData.data.email,
                                firstName: currentUserData.data.first_name,
                                lastName: currentUserData.data.last_name,
                                userId: String(currentUserData.data.id)
                            });
                            // console.log('🎯 Conversão disparada: Primeiro cliente criado');
                        }
                        catch (error) {
                            console.error('Erro ao buscar dados do usuário para conversão:', error);
                        }
                    }
                    showToast("success", "Cliente adicionado com sucesso!");
                    return [3 /*break*/, 4];
                case 3:
                    error_5 = _a.sent();
                    console.error("Erro ao adicionar cliente:", error_5);
                    showToast("error", "Erro ao adicionar cliente. Tente novamente.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // ===== Novo: adiciona cliente temporário "Cliente N" =====
    var handleAddTempClient = function () {
        // requer plataforma conectada (mesma regra anterior)
        if (!isGoogleConnected && !isFacebookConnected) {
            setShowConnectWarning(true);
            return;
        }
        setShowConnectWarning(false);
        if (reachedClientLimit) {
            showToast("error", "Voc\u00EA atingiu o limite de ".concat(clientLimit, " clientes do seu plano."));
            return;
        }
        var nextNumber = localClients.length + 1;
        var tempId = "temp-".concat(Date.now());
        var tempClient = {
            id: tempId,
            name: "Cliente ".concat(nextNumber),
            google: null,
            facebook: null,
            instagram: null,
            status: true,
            onboarded_at: null,
            display_order: localClients.length,
            isTemporary: true,
        };
        setLocalClients(function (prev) { return __spreadArray(__spreadArray([], prev, true), [tempClient], false); });
    };
    var handleDeleteClient = function () { return __awaiter(void 0, void 0, void 0, function () {
        var clientToRemove, error_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!clientToDelete)
                        return [2 /*return*/];
                    clientToRemove = localClients.find(function (c) { return c.id === clientToDelete; });
                    if (clientToRemove === null || clientToRemove === void 0 ? void 0 : clientToRemove.isTemporary) {
                        setLocalClients(function (prevClients) { return prevClients.filter(function (client) { return client.id !== clientToDelete; }); });
                        setClientToDelete(null);
                        showToast("success", "Cliente removido com sucesso!");
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, deleteClient(clientToDelete)];
                case 2:
                    _a.sent();
                    setLocalClients(function (prevClients) { return prevClients.filter(function (client) { return client.id !== clientToDelete; }); });
                    setClientToDelete(null);
                    showToast("success", "Cliente excluído com sucesso!");
                    return [3 /*break*/, 4];
                case 3:
                    error_6 = _a.sent();
                    console.error("Erro ao excluir cliente:", error_6);
                    showToast("error", "Erro ao excluir cliente. Tente novamente.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var openDeleteModal = function (clientId) {
        setClientToDelete(clientId);
    };
    var onDragEnd = function (result) {
        if (!result.destination)
            return;
        var sourceIdx = result.source.index;
        var destIdx = result.destination.index;
        if (sourceIdx === destIdx)
            return;
        var reordered = Array.from(localClients);
        var moved = reordered.splice(sourceIdx, 1)[0];
        reordered.splice(destIdx, 0, moved);
        var withOrder = reordered.map(function (c, idx) {
            var _a;
            return (__assign(__assign({}, c), { display_order: idx, google_mcc_id: (_a = c.google_mcc_id) !== null && _a !== void 0 ? _a : null }));
        });
        setLocalClients(withOrder);
        setOrderChanged(true);
    };
    var handleSyncAllAssociations = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsSyncing(true);
                    return [4 /*yield*/, runWithSnakeModal(function () { return __awaiter(void 0, void 0, void 0, function () {
                            var savedClients, _i, localClients_1, client, hasAccount, response, newClient, error_7, agencyId, error_8;
                            var _a, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        _c.trys.push([0, 13, 14, 15]);
                                        savedClients = [];
                                        _i = 0, localClients_1 = localClients;
                                        _c.label = 1;
                                    case 1:
                                        if (!(_i < localClients_1.length)) return [3 /*break*/, 10];
                                        client = localClients_1[_i];
                                        hasAccount = client.google || client.facebook || client.instagram;
                                        if (!hasAccount) {
                                            return [3 /*break*/, 9]; // Pula clientes sem contas
                                        }
                                        if (!client.isTemporary) return [3 /*break*/, 7];
                                        _c.label = 2;
                                    case 2:
                                        _c.trys.push([2, 5, , 6]);
                                        return [4 /*yield*/, createClient(client.name)];
                                    case 3:
                                        response = _c.sent();
                                        newClient = response.data;
                                        // Associa as contas
                                        return [4 /*yield*/, associateAccounts(String(newClient.id), client.google, client.facebook, client.instagram, (_a = client.display_order) !== null && _a !== void 0 ? _a : 0, client.status !== undefined ? client.status : true, client.name, client.onboarded_at || null, client.google_mcc_id || null)];
                                    case 4:
                                        // Associa as contas
                                        _c.sent();
                                        savedClients.push(__assign(__assign({}, client), { id: String(newClient.id), isTemporary: false }));
                                        // Conversão se for o primeiro cliente
                                        if (originalClients.length === 0 && savedClients.length === 1) {
                                            try {
                                                trackFirstClientCreated({
                                                    email: currentUserData.data.email,
                                                    firstName: currentUserData.data.first_name,
                                                    lastName: currentUserData.data.last_name,
                                                    userId: String(currentUserData.data.id)
                                                });
                                                // console.log('🎯 Conversão disparada: Primeiro cliente criado');
                                            }
                                            catch (error) {
                                                console.error('Erro ao buscar dados do usuário para conversão:', error);
                                            }
                                        }
                                        return [3 /*break*/, 6];
                                    case 5:
                                        error_7 = _c.sent();
                                        console.error("Erro ao criar cliente ".concat(client.name, ":"), error_7);
                                        return [3 /*break*/, 6];
                                    case 6: return [3 /*break*/, 9];
                                    case 7: 
                                    // Cliente já existe, apenas atualiza
                                    return [4 /*yield*/, associateAccounts(client.id, client.google, client.facebook, client.instagram, (_b = client.display_order) !== null && _b !== void 0 ? _b : 0, client.status !== undefined ? client.status : true, client.name, client.onboarded_at || null, client.google_mcc_id || null)];
                                    case 8:
                                        // Cliente já existe, apenas atualiza
                                        _c.sent();
                                        savedClients.push(client);
                                        _c.label = 9;
                                    case 9:
                                        _i++;
                                        return [3 /*break*/, 1];
                                    case 10:
                                        agencyId = agency.id || null;
                                        if (!agencyId) return [3 /*break*/, 12];
                                        return [4 /*yield*/, updateAgencyCache(agencyId)];
                                    case 11:
                                        _c.sent();
                                        _c.label = 12;
                                    case 12:
                                        // Atualiza a lista local apenas com clientes salvos
                                        setLocalClients(savedClients);
                                        setOriginalClients(savedClients);
                                        setOrderChanged(false);
                                        showToast("success", "".concat(savedClients.length, " cliente(s) salvos com sucesso!"));
                                        return [3 /*break*/, 15];
                                    case 13:
                                        error_8 = _c.sent();
                                        console.error("Erro ao sincronizar associações:", error_8);
                                        showToast("error", "Erro ao sincronizar. Tente novamente.");
                                        return [3 /*break*/, 15];
                                    case 14:
                                        setIsSyncing(false);
                                        return [7 /*endfinally*/];
                                    case 15: return [2 /*return*/];
                                }
                            });
                        }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleInactivateClient = function () { return __awaiter(void 0, void 0, void 0, function () {
        var clientToInactivate, updatedClients, error_9;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!clientToDelete)
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, 5, 6]);
                    clientToInactivate = localClients.find(function (c) { return c.id === clientToDelete; });
                    if (!clientToInactivate) return [3 /*break*/, 3];
                    updatedClients = localClients.map(function (c) {
                        return c.id === clientToDelete ? __assign(__assign({}, c), { status: false }) : c;
                    });
                    setLocalClients(updatedClients);
                    return [4 /*yield*/, associateAccounts(clientToInactivate.id, clientToInactivate.google, clientToInactivate.facebook, clientToInactivate.instagram, (_a = clientToInactivate.display_order) !== null && _a !== void 0 ? _a : 0, false, clientToInactivate.name, clientToInactivate.onboarded_at || null)];
                case 2:
                    _b.sent();
                    showToast("success", "Cliente \"".concat(clientToInactivate.name, "\" foi inativado com sucesso!"));
                    _b.label = 3;
                case 3: return [3 /*break*/, 6];
                case 4:
                    error_9 = _b.sent();
                    console.error("Erro ao inativar cliente:", error_9);
                    showToast("error", "Erro ao inativar o cliente. Tente novamente.");
                    return [3 /*break*/, 6];
                case 5:
                    setClientToDelete(null);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var hasChanges = function () {
        if (orderChanged)
            return true;
        // ✅ Se tem clientes temporários com contas selecionadas, há mudanças
        var hasTemporaryWithAccounts = localClients.some(function (c) { return c.isTemporary && (c.google || c.facebook || c.instagram); });
        if (hasTemporaryWithAccounts)
            return true;
        if (originalClients.length !== localClients.filter(function (c) { return !c.isTemporary; }).length)
            return true;
        return localClients.some(function (client) {
            if (client.isTemporary)
                return false;
            var original = originalClients.find(function (c) { return c.id === client.id; });
            if (!original)
                return true;
            return (client.google !== original.google ||
                client.facebook !== original.facebook ||
                client.instagram !== original.instagram ||
                client.status !== original.status ||
                client.onboarded_at !== original.onboarded_at ||
                client.name !== original.name);
        });
    };
    var facebookOptions = facebookAccounts.map(function (acc) { return ({
        value: acc.id,
        label: acc.name
    }); });
    var googleOptions = googleAccounts.map(function (acc) { return ({
        value: acc.id,
        label: acc.parent_mcc
            ? (React.createElement("span", null,
                acc.name,
                React.createElement("span", { style: {
                        background: "#074853",
                        color: "#bf0505",
                        borderRadius: "15px",
                        fontSize: "0.75em",
                        padding: "2px 7px",
                        marginLeft: "8px",
                        fontWeight: 600,
                        verticalAlign: "middle",
                        display: "inline-block"
                    } }, "BM")))
            : acc.name,
        parent_mcc: (acc === null || acc === void 0 ? void 0 : acc.parent_mcc) || null
    }); });
    var instagramOptions = instagramAccounts.map(function (account) { return ({
        value: account.id,
        label: account.page_name || account.id,
        instagram_username: account.instagram_username,
    }); });
    var customStyles = {
        option: function (provided, state) { return (__assign(__assign({}, provided), { color: state.data.isSpecial ? "green" : "white", fontWeight: state.data.isSpecial ? "bold" : "normal", backgroundColor: state.isFocused ? "#1f2937" : "#111827", cursor: "pointer" })); },
        control: function (provided) { return (__assign(__assign({}, provided), { backgroundColor: "#1f2937", borderColor: "#374151", color: "white" })); },
        singleValue: function (provided) { return (__assign(__assign({}, provided), { color: "white" })); },
        menu: function (provided) { return (__assign(__assign({}, provided), { backgroundColor: "#111827" })); },
    };
    var mainSubscription = activeSubscriptions.find(function (sub) { return sub.plan_type === "main"; });
    var clientLimit = mainSubscription ? mainSubscription.client_limit : (isInTrialPeriod ? 9999 : 1);
    var reachedClientLimit = localClients.filter(function (c) { return !c.isTemporary; }).length >= clientLimit;
    // hasPremiumAccess, isInTrialPeriod, hasActivePlan, trialDaysLeft, trialCreatedAt, isLoading: isPremiumLoading
    var showTrialMessage = !hasActivePlan && isInTrialPeriod && typeof trialDaysLeft === "number" && trialDaysLeft > 0;
    // Mensagens dinâmicas para o trial
    var trialHeader = "";
    var trialCta = "";
    if (trialDaysLeft > 3) {
        trialHeader = "Per\u00EDodo de Teste:\n Restam ".concat(trialDaysLeft, " ").concat(trialDaysLeft === 1 ? 'dia' : 'dias', " com clientes ilimitados.");
        trialCta = "Evitar perda de monitoramento";
    }
    else if (trialDaysLeft > 1) {
        trialHeader = "\u26A0\uFE0F Faltam apenas ".concat(trialDaysLeft, " dias para o fim do seu teste.");
        trialCta = "Continuar monitorando todos os clientes";
    }
    else if (trialDaysLeft === 1) {
        trialHeader = "⏰ Último dia de teste! Seus clientes serão desativados amanhã.";
        trialCta = "Manter todos os clientes ativos";
    }
    // Exibe loader enquanto dados premium/trial estão carregando
    if (isPremiumLoading) {
        return (React.createElement("div", { className: "w-full flex justify-center py-6" },
            React.createElement("span", { className: "text-gray-300 text-sm" }, "Carregando informa\u00E7\u00F5es da ag\u00EAncia...")));
    }
    return (React.createElement(React.Fragment, null,
        notification && (React.createElement("div", { className: "fixed top-5 right-5 px-4 py-2 rounded-lg shadow-lg text-white ".concat(notification.type === "success" ? "bg-green-500" : "bg-red-500") }, notification.message)),
        React.createElement(ConfirmationModal, { isOpen: !!clientToDelete, title: "Excluir Cliente?", message: "Deseja realmente excluir este cliente do Vision Cockpit?", onConfirm: handleDeleteClient, onCancel: function () { return setClientToDelete(null); }, showInactivateOption: !((_b = localClients.find(function (c) { return c.id === clientToDelete; })) === null || _b === void 0 ? void 0 : _b.isTemporary), onInactivate: handleInactivateClient, clientName: clientToDelete ? (_c = localClients.find(function (c) { return c.id === clientToDelete; })) === null || _c === void 0 ? void 0 : _c.name : '' }),
        (isGoogleConnected || isFacebookConnected) && !(Array.isArray(localClients) && localClients.some(function (c) { return !c.isTemporary; })) && (React.createElement("div", { className: "w-full flex justify-center mb-2" },
            React.createElement("div", { className: "bg-gray-800/80 text-gray-300 px-2 py-0 rounded text-xs md:text-sm shadow-sm font-normal" }, "\u2728 Selecione as contas de an\u00FAncios dos seus clientes abaixo"))),
        reachedClientLimit && (React.createElement("div", { className: "w-full flex justify-center" },
            React.createElement("div", { className: "text-red-600 mt-1 text-sm flex flex-col items-center gap-2" }, isInTrialPeriod ? (React.createElement(React.Fragment, null,
                "Voc\u00EA est\u00E1 utilizando o plano free.",
                React.createElement("span", { className: "animate-pulse font-bold", style: { color: "rgb(38, 220, 202)" } },
                    "Restam ",
                    trialDaysLeft,
                    " ",
                    trialDaysLeft === 1 ? 'dia' : 'dias',
                    " com clientes ilimitados."),
                React.createElement("button", { className: "mt-1 mb-4 px-4 py-1 bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500 text-white font-bold rounded shadow hover:from-yellow-500 hover:to-red-600 transition-all animate-bounce", onClick: function () { return window.location.href = "/subscription"; } }, "Garanta clientes ilimitados permanentemente"))) : null))),
        showTrialMessage && (React.createElement("div", { className: "w-full flex justify-center mt-2 mb-4" },
            React.createElement("div", { className: "text-yellow-400 text-xs md:text-sm flex flex-col items-center gap-2 ".concat(trialDaysLeft === 1 ? "bg-yellow-900/80 border-2 border-yellow-400 rounded-lg p-2 shadow-lg" : "") },
                React.createElement("span", { className: "flex items-center gap-1 font-semibold" }, trialHeader),
                React.createElement("button", { className: "\n                mt-1 px-4 py-1 font-bold rounded shadow\n                transition-all\n                ".concat(trialDaysLeft === 1
                        ? "bg-yellow-400 text-gray-900 border border-yellow-500 hover:bg-yellow-300"
                        : "bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500 text-white hover:from-yellow-500 hover:to-red-600", "\n                animate-bounce\n              "), onClick: function () { return window.location.href = "/subscription"; } }, trialCta)))),
        Array.isArray(localClients) && localClients.length > 0 ? (React.createElement("div", { className: "hidden lg:block overflow-x-auto" },
            React.createElement("table", { className: "w-full" },
                React.createElement("thead", { className: "bg-gray-800/50 border-b border-gray-700" },
                    React.createElement("tr", null,
                        React.createElement("th", { className: "p-3 text-center text-gray-400 font-semibold cursor-default select-none uppercase tracking-wider", scope: "col", "aria-disabled": "true", title: "Cabe\u00E7alho da coluna \u2014 n\u00E3o \u00E9 um bot\u00E3o" }),
                        React.createElement("th", { className: "p-3 text-center text-gray-400 font-semibold cursor-default select-none uppercase tracking-wider", scope: "col", "aria-disabled": "true", title: "Cabe\u00E7alho da coluna \u2014 n\u00E3o \u00E9 um bot\u00E3o" }, "Google Ads"),
                        React.createElement("th", { className: "p-3 text-center text-gray-400 font-semibold cursor-default select-none uppercase tracking-wider", scope: "col", "aria-disabled": "true", title: "Cabe\u00E7alho da coluna \u2014 n\u00E3o \u00E9 um bot\u00E3o" }, "Facebook Ads"),
                        React.createElement("th", { className: "p-3 text-center text-gray-400 font-semibold cursor-default select-none uppercase tracking-wider", scope: "col", "aria-disabled": "true", title: "Cabe\u00E7alho da coluna \u2014 n\u00E3o \u00E9 um bot\u00E3o" }, "Instagram"),
                        React.createElement("th", { className: "p-3 text-center text-gray-400 font-semibold cursor-default select-none uppercase tracking-wider", scope: "col", "aria-disabled": "true", title: "Cabe\u00E7alho da coluna \u2014 n\u00E3o \u00E9 um bot\u00E3o" }))),
                React.createElement(DragDropContext, { onDragEnd: onDragEnd },
                    React.createElement(Droppable, { droppableId: "clients-droppable-desktop" }, function (provided) { return (React.createElement("tbody", __assign({ ref: provided.innerRef }, provided.droppableProps),
                        isLoadingClients ? (React.createElement("tr", null,
                            React.createElement("td", { colSpan: 6, className: "text-center py-8" },
                                React.createElement("div", { className: "flex flex-col items-center justify-center gap-3" },
                                    React.createElement("span", { className: "flex items-center justify-center" },
                                        React.createElement("svg", { className: "animate-spin h-8 w-8", viewBox: "0 0 24 24" },
                                            React.createElement("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4", fill: "none" }),
                                            React.createElement("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8v8z" }))),
                                    React.createElement("p", { className: "text-gray-400 animate-pulse mt-2" }, "Carregando Clientes..."))))) : Array.isArray(localClients) && localClients.length > 0 ? (localClients.map(function (client, index) { return (React.createElement(Draggable, { key: client.id, draggableId: client.id, index: index }, function (provided, snapshot) { return (React.createElement(ClientTableRow, { showTrialMessage: showTrialMessage, client: client, googleOptions: googleOptions, facebookOptions: facebookOptions, instagramOptions: instagramOptions, customStyles: customStyles, handleClientChange: handleClientChange, handleSaveAssociation: handleSaveAssociation, openDeleteModal: openDeleteModal, handleFacebookAccountChange: handleFacebookAccountChange, loadingGoogle: loadingGoogleAccounts, loadingFacebook: loadingFacebookAccounts, loadingInstagram: loadingInstagramAccounts, isInactive: client.status === false, provided: provided, snapshot: snapshot, dragHandleProps: provided.dragHandleProps, draggableProps: provided.draggableProps })); })); })) : (React.createElement("tr", null,
                            React.createElement("td", { colSpan: 6, className: "tutorial-vincular-contas-cliente text-center text-gray-500 py-6" }, "Nenhum cliente encontrado."))),
                        provided.placeholder)); }))))) : null,
        Array.isArray(localClients) && localClients.length > 0 ? (React.createElement("div", { className: "block lg:hidden" },
            React.createElement(DragDropContext, { onDragEnd: onDragEnd },
                React.createElement(Droppable, { droppableId: "clients-droppable-mobile" }, function (provided) { return (React.createElement("div", __assign({ ref: provided.innerRef }, provided.droppableProps),
                    isLoadingClients ? (React.createElement("div", { className: "text-center py-8" },
                        React.createElement("div", { className: "flex flex-col items-center justify-center gap-3" },
                            React.createElement("span", { className: "flex items-center justify-center" },
                                React.createElement("svg", { className: "animate-spin h-8 w-8", viewBox: "0 0 24 24" },
                                    React.createElement("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4", fill: "none" }),
                                    React.createElement("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8v8z" }))),
                            React.createElement("p", { className: "text-gray-400 animate-pulse mt-2" }, "Carregando Clientes...")))) : Array.isArray(localClients) && localClients.length > 0 ? (localClients.map(function (client, index) { return (React.createElement(Draggable, { key: client.id, draggableId: "mobile-".concat(client.id), index: index }, function (provided, snapshot) { return (React.createElement(ClientTableRow, { client: client, googleOptions: googleOptions, facebookOptions: facebookOptions, instagramOptions: instagramOptions, customStyles: customStyles, handleClientChange: handleClientChange, handleSaveAssociation: handleSaveAssociation, openDeleteModal: openDeleteModal, handleFacebookAccountChange: handleFacebookAccountChange, loadingGoogle: loadingGoogleAccounts, loadingFacebook: loadingFacebookAccounts, loadingInstagram: loadingInstagramAccounts, isInactive: client.status === false, provided: provided, snapshot: snapshot, dragHandleProps: provided.dragHandleProps, draggableProps: provided.draggableProps })); })); })) : (React.createElement("div", { className: "tutorial-vincular-contas-cliente text-center text-gray-500 py-6" }, "Nenhum cliente encontrado.")),
                    provided.placeholder)); })))) : null,
        React.createElement("div", { className: "tutorial-criar-cliente mb-8 flex justify-center w-full" },
            React.createElement("button", { onClick: handleAddTempClient, disabled: reachedClientLimit || (!isGoogleConnected && !isFacebookConnected), title: reachedClientLimit
                    ? "Limite máximo de clientes atingido"
                    : (!isGoogleConnected && !isFacebookConnected)
                        ? "Conecte Google Ads ou Facebook Ads para adicionar clientes"
                        : "Acrescentar +1 cliente com nome automático", className: "\n            w-full flex items-center justify-center gap-3\n            px-0 py-0\n            rounded-sm\n            transition-all duration-200\n            shadow-md\n            group\n            ".concat(reachedClientLimit || (!isGoogleConnected && !isFacebookConnected)
                    ? "opacity-50 cursor-not-allowed bg-gray-700"
                    : "bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 hover:scale-[1.02] active:scale-[0.98] focus:ring-2 focus:ring-green-400", "\n          "), style: {
                    minHeight: 40,
                    fontWeight: 700,
                    fontSize: 18,
                    letterSpacing: 0.5,
                    margin: "0 25px",
                    background: "#a4b3ce0f",
                    border: "1px solid #394150",
                } },
                React.createElement("span", { className: "\n            flex items-center justify-center\n            h-full px-3 py-0\n            rounded-l-sm\n            bg-green-700/20\n            transition-all duration-200\n            group-hover:bg-green-800/30\n            group-active:bg-green-900/40\n          " },
                    React.createElement(Plus, { className: "w-6 h-6 text-white drop-shadow" })),
                React.createElement("span", { className: "flex-1 text-white font-bold tracking-wide py-0" },
                    "Acrescentar ",
                    React.createElement("span", { className: "font-extrabold" }, "+1 cliente")))),
        hasChanges() ? (React.createElement("div", { className: "mb-6 mt-6 flex flex-col items-center gap-2" },
            React.createElement("button", { onClick: handleSyncAllAssociations, className: "flex items-center justify-center gap-2 px-6 py-2 bg-gradient-to-r from-green-400 to-green-600 text-white font-semibold rounded-lg shadow-md hover:from-green-500 hover:to-green-700 transition-all duration-300 disabled:opacity-60", disabled: isSyncing }, isSyncing ? (React.createElement(React.Fragment, null,
                React.createElement(Loader2, { className: "animate-spin w-5 h-5" }),
                "Aguarde, sincronizando dados entre plataformas...")) : (React.createElement("span", { className: "flex items-center gap-2 group" },
                React.createElement(RefreshCw, { className: "w-5 h-5 transition-transform duration-200 group-hover:-rotate-12 group-hover:scale-110" }),
                "Salvar e Sincronizar Dados"))),
            isSyncing && (React.createElement("span", { className: "text-sm text-gray-300 mt-2" }, "Dependendo de sua quantidade de clientes, a sincroniza\u00E7\u00E3o pode demorar at\u00E9 1 minuto...")))) : (React.createElement(React.Fragment, null, " ")),
        React.createElement("div", { style: { margin: 30, display: "flex", justifyContent: "center" } }, !hasChanges() && localClients.some(function (c) { return !c.isTemporary; }) ? (React.createElement("div", { className: "mb-6 mt-6 flex flex-col items-center gap-2" },
            React.createElement("button", { onClick: function () { return navigate("/monitoramento"); }, className: "flex items-center justify-center gap-3 px-7 py-2 bg-gradient-to-r from-cyan-400 to-blue-600 text-white font-bold rounded-lg shadow-lg hover:from-cyan-500 hover:to-blue-700 transition-all duration-300 text-lg" },
                React.createElement("span", { className: "relative flex items-center" },
                    React.createElement("span", { className: "absolute -inset-1 rounded-full bg-cyan-400/20 blur-sm opacity-60 animate-pulse" }),
                    React.createElement(Monitor, { className: "w-6 h-6 text-cyan-200 relative z-10 animate-bounce" })),
                "Ir para Monitoramento"))) : null)));
};
export default ClientTable;
